var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B33221",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28 21v9.333m0 9.334v.023m-16.318 9.3h32.636c5.402 0 8.768-5.86 6.047-10.526L34.048 10.475c-2.701-4.632-9.394-4.632-12.095 0L5.635 38.464c-2.72 4.666.646 10.526 6.047 10.526m16.902-9.324a.583.583 0 1 1-1.167 0 .583.583 0 0 1 1.167 0"
  })));
};
export default SvgAlert;